import { render, staticRenderFns } from "./MobBottomNav.vue?vue&type=template&id=0a99e550&scoped=true"
import script from "./MobBottomNav.vue?vue&type=script&lang=js"
export * from "./MobBottomNav.vue?vue&type=script&lang=js"
import style0 from "./MobBottomNav.vue?vue&type=style&index=0&id=0a99e550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99e550",
  null
  
)

export default component.exports